export default {
    "trs.front.title.left.menu.dashboard": "ホーム",
    "trs.front.title.left.menu.deposit": "入金",
    "trs.front.title.left.menu.withdraw": "出金",
    "trs.front.title.left.menu.transfer": "振替",
    "trs.front.title.left.menu.history": "履歴",
    "trs.front.title.left.menu.reports": "報告書",
    "trs.front.title.left.menu.my_performance": "マイパフォーマンス",
    "trs.front.title.left.menu.affiliate": "アフィリエイト",
    "trs.front.title.left.menu.bank_account": "報告書閲覧",
    "trs.front.title.left.menu.account_info": "お客様情報",
    "trs.front.title.left.menu.support": "お客様サポート",
    "trs.front.title.left.menu.homepage": "ホームページへ",
    "trs.front.title.left.menu.setting": "設定",
}
